
import { useIntersectionObserver } from "../hooks/useIntersectionObserver";

const WealthSection = () => {
  const [ref, isVisible] = useIntersectionObserver();
  return <section ref={ref} className={`py-12 md:py-24 px-6 bg-surface transition-all duration-1000 transform ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
      <div className="max-w-[1200px] mx-auto text-center space-y-6 md:space-y-12">
        <p className="text-xs md:text-sm tracking-widest uppercase text-secondary font-medium">
          LET'S TALK GROWTH
        </p>
        
        <h2 className="text-[2.25rem] leading-[1.1] md:text-6xl font-medium tracking-tight text-primary font-charter">
          Media planning for a digital age
        </h2>
        
        <div className="max-w-[800px] mx-auto text-sm md:text-xl text-secondary">
          <p>
            Media planning shouldn't be complicated or time-consuming. We've built a modern approach that puts you in control. Whether you're managing campaigns, optimizing budgets, or forecasting future performance, planniFi makes it easier to take charge of your media strategy.
          </p>
        </div>

        <div className="flex items-center justify-center gap-4 md:gap-8 flex-wrap text-xs md:text-sm text-secondary tracking-widest">
          <span className="font-medium">BUDGET</span>
          <span className="w-1 h-1 rounded-full bg-secondary"></span>
          <span className="font-medium">PLAN</span>
          <span className="w-1 h-1 rounded-full bg-secondary"></span>
          <span className="font-medium">TRACK</span>
        </div>
      </div>
    </section>;
};
export default WealthSection;
